import DaoBase from "./base";

/**
 * 하단 플레이어에서 사용되는 음원객체
 */
export default class DaoPlayerMedia extends DaoBase {
    date;
    at;
    type;
    serviceid;
    groupid;
    songid;
    songname;
    artistname;
    albumname;
    title_yn;
    bset_yn;
    mp3name;
    playtime;
    favorite;
    image;

    constructor(json=null) {
        super(json);
    }

    get isFavorite() {
        return this.favorite === 'Y';
    }
}


// WEBPACK FOOTER //
// ./src/modules/dao/player.media.js